var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUnopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 41,
    viewBox: "0 0 80 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 39,
    rx: 9.29851,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1094 12.332H64.0571M42.1094 20.4808H64.0571M42.1094 29.3094H64.0571",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20C22.0185 20 20 17.9815 20 15.5C20 13.0185 22.0185 11 24.5 11C26.9815 11 29 13.0185 29 15.5C29 17.9815 26.9815 20 24.5 20ZM24.5 11.8182C22.4701 11.8182 20.8182 13.4701 20.8182 15.5C20.8182 17.5299 22.4701 19.1818 24.5 19.1818C26.5299 19.1818 28.1818 17.5299 28.1818 15.5C28.1818 13.4701 26.5299 11.8182 24.5 11.8182Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6579 31H17.3421C16.6022 31 16 30.327 16 29.5C16 29.432 16.0125 27.815 17.0961 26.2C17.7268 25.26 18.5903 24.513 19.6631 23.981C20.9729 23.33 22.6005 23 24.5 23C26.3995 23 28.0271 23.33 29.3369 23.981C30.4097 24.514 31.2732 25.26 31.9039 26.2C32.9875 27.815 33 29.432 33 29.5C33 30.327 32.3978 31 31.6579 31ZM24.5 24C21.3801 24 19.0779 24.953 17.8423 26.756C16.9162 28.107 16.8956 29.488 16.8947 29.502C16.8952 29.6343 16.9426 29.7609 17.0264 29.8543C17.1102 29.9476 17.2238 30 17.3421 30H31.6579C31.7765 30 31.8903 29.9473 31.9742 29.8536C32.0581 29.7598 32.1053 29.6326 32.1053 29.5C32.1053 29.488 32.0847 28.107 31.1577 26.756C29.9212 24.953 27.6191 24 24.5 24Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUnopen);
export default __webpack_public_path__ + "static/media/Profile Unopen.afda585d4de8bc778dbf5a5e609e8388.svg";
export { ForwardRef as ReactComponent };